import React from 'react';

export function SSLogo({ size = 40, className = '' }) {
  const s = size;
  return (
    <svg viewBox="0 0 200 60" width={s * 3.3} height={s} className={`flex-shrink-0 ${className}`}>
      <defs>
        <linearGradient id="ssBrand" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#0D9488" />
          <stop offset="100%" stopColor="#2DD4BF" />
        </linearGradient>
      </defs>
      {/* SHOP */}
      <text x="0" y="38" fill="#111827" fontSize="34" fontWeight="800" fontFamily="'Space Grotesk', Arial, sans-serif" letterSpacing="-0.5">SHOP</text>
      {/* & symbol - accent color */}
      <text x="92" y="38" fill="url(#ssBrand)" fontSize="34" fontWeight="800" fontFamily="'Space Grotesk', Arial, sans-serif">&amp;</text>
      {/* SHIP */}
      <text x="118" y="38" fill="#111827" fontSize="34" fontWeight="800" fontFamily="'Space Grotesk', Arial, sans-serif" letterSpacing="-0.5">SHIP</text>
      {/* Underline accent bar */}
      <rect x="0" y="46" width="80" height="3" rx="1.5" fill="url(#ssBrand)" />
      {/* Tagline */}
      <text x="0" y="58" fill="#6b7280" fontSize="8" fontWeight="500" fontFamily="'Inter', Arial, sans-serif" letterSpacing="3">SELL  ·  EARN  ·  GROW</text>
    </svg>
  );
}

export function SSLogoIcon({ size = 40, className = '' }) {
  return (
    <svg viewBox="0 0 50 50" width={size} height={size} className={`flex-shrink-0 ${className}`}>
      <defs>
        <linearGradient id="ssIconGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0D9488" />
          <stop offset="100%" stopColor="#2DD4BF" />
        </linearGradient>
      </defs>
      <rect width="50" height="50" rx="12" fill="url(#ssIconGrad)" />
      <text x="25" y="24" textAnchor="middle" fill="white" fontSize="14" fontWeight="800" fontFamily="'Space Grotesk', Arial, sans-serif">S&S</text>
      <rect x="10" y="30" width="30" height="2" rx="1" fill="white" opacity="0.4" />
      <text x="25" y="42" textAnchor="middle" fill="white" fontSize="6" fontWeight="600" fontFamily="'Inter', Arial, sans-serif" letterSpacing="1" opacity="0.7">SHOP&SHIP</text>
    </svg>
  );
}

export function SSLogoFull({ className = '' }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} dir="ltr">
      <SSLogoIcon size={38} />
      <div>
        <div className="flex items-center gap-1">
          <span className="font-heading text-base font-extrabold text-gray-900 tracking-tight">SHOP</span>
          <span className="font-heading text-base font-extrabold text-primary">&</span>
          <span className="font-heading text-base font-extrabold text-gray-900 tracking-tight">SHIP</span>
        </div>
        <p className="text-[8px] text-muted-foreground tracking-[3px] uppercase">Sell · Earn · Grow</p>
      </div>
    </div>
  );
}

export default SSLogo;
